var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66666H2.66668C1.93334 2.66666 1.34001 3.26666 1.34001 4L1.33334 12C1.33334 12.7333 1.93334 13.3333 2.66668 13.3333H13.3333C14.0667 13.3333 14.6667 12.7333 14.6667 12V4C14.6667 3.26666 14.0667 2.66666 13.3333 2.66666ZM13.0667 5.5L8.35334 8.44666C8.14001 8.58 7.86001 8.58 7.64668 8.44666L2.93334 5.5C2.8665 5.46247 2.80796 5.41177 2.76127 5.35097C2.71458 5.29016 2.68072 5.22052 2.66173 5.14624C2.64274 5.07197 2.63901 4.99462 2.65078 4.91887C2.66255 4.84312 2.68957 4.77054 2.7302 4.70553C2.77083 4.64052 2.82423 4.58443 2.88716 4.54066C2.9501 4.49689 3.02126 4.46634 3.09634 4.45086C3.17142 4.43539 3.24887 4.43531 3.32398 4.45063C3.39909 4.46595 3.47032 4.49635 3.53334 4.54L8.00001 7.33333L12.4667 4.54C12.5297 4.49635 12.6009 4.46595 12.676 4.45063C12.7512 4.43531 12.8286 4.43539 12.9037 4.45086C12.9788 4.46634 13.0499 4.49689 13.1129 4.54066C13.1758 4.58443 13.2292 4.64052 13.2698 4.70553C13.3105 4.77054 13.3375 4.84312 13.3492 4.91887C13.361 4.99462 13.3573 5.07197 13.3383 5.14624C13.3193 5.22052 13.2854 5.29016 13.2388 5.35097C13.1921 5.41177 13.1335 5.46247 13.0667 5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mail.icon.f4adcefee0213751bd8d6bebdeb884cf.svg";
export { ForwardRef as ReactComponent };